import { z } from 'zod';
import { CREDENTIAL_PROVIDERS } from '../enums';

/**
 * Credentials (API_DOCS.md — Credentials). Plaintext NEVER appears in a response
 * (AI_RULES §9): the read model carries only a masked hint.
 */

export const credentialStatusSchema = z.object({
  provider: z.enum(CREDENTIAL_PROVIDERS),
  isSet: z.boolean(),
  isActive: z.boolean(),
  lastVerifiedAt: z.string().datetime().nullable(),
  /** Last 4 characters of the api key behind a mask, e.g. "···k3F9". Never the secret. */
  maskedHint: z.string().nullable(),
  updatedAt: z.string().datetime().nullable(),
});
export type CredentialStatus = z.infer<typeof credentialStatusSchema>;

export const credentialUpsertSchema = z.object({
  apiKey: z.string().min(1).max(512),
  secret: z.string().min(1).max(512).optional(),
});
export type CredentialUpsert = z.infer<typeof credentialUpsertSchema>;

export const credentialVerifyResponseSchema = z.object({
  ok: z.boolean(),
  detail: z.string(),
});
export type CredentialVerifyResponse = z.infer<typeof credentialVerifyResponseSchema>;
